(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("eQS2b", function(module, exports) {
var $acffd6143d01083a$var$insuranceEventForms = document.querySelectorAll(".f-return-car");
$acffd6143d01083a$var$insuranceEventForms.forEach(function(form) {
    var carModelInput = form.querySelector(".f-return-car__car-model");
    var carBrandSelect = form.querySelector(".f-return-car__car-brand select");
    var disableCarModel = function(disable) {
        if (disable) carModelInput === null || carModelInput === void 0 || carModelInput.classList.add("--disabled");
        else carModelInput === null || carModelInput === void 0 || carModelInput.classList.remove("--disabled");
    };
    carBrandSelect === null || carBrandSelect === void 0 || carBrandSelect.addEventListener("change", function() {
        disableCarModel(!(carBrandSelect === null || carBrandSelect === void 0 ? void 0 : carBrandSelect.value));
    });
    disableCarModel(!(carBrandSelect === null || carBrandSelect === void 0 ? void 0 : carBrandSelect.value));
});

});

})();
//# sourceMappingURL=return-car-form.d343a817.js.map
